export default __webpack_public_path__ + "static/lawn-mower-354acc1bd286d2d72c08652acde7a09d.webp";